
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { VenueFormValues } from "./types";

type CoordinatesSectionProps = {
  form: UseFormReturn<VenueFormValues>;
};

export function CoordinatesSection({ form }: CoordinatesSectionProps) {
  return (
    <div className="grid grid-cols-2 gap-4">
      <FormField
        control={form.control}
        name="latitude"
        render={({ field: { value, onChange, ...field } }) => (
          <FormItem>
            <FormLabel>Latitude</FormLabel>
            <FormControl>
              <Input
                type="number"
                step="any"
                placeholder="Latitude"
                value={value !== undefined ? value : ""}
                onChange={(e) => onChange(e.target.value ? parseFloat(e.target.value) : undefined)}
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="longitude"
        render={({ field: { value, onChange, ...field } }) => (
          <FormItem>
            <FormLabel>Longitude</FormLabel>
            <FormControl>
              <Input
                type="number"
                step="any"
                placeholder="Longitude"
                value={value !== undefined ? value : ""}
                onChange={(e) => onChange(e.target.value ? parseFloat(e.target.value) : undefined)}
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
